module.exports = __webpack_public_path__ + "static/media/person.6515d4b6.svg";